import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';
import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';
import { PRODUCTS_TYPES_FORMATS } from '@/ebat/constants';

export const ProductDefaultProps = {
  ...ClassNameDefaultProps,
  ...DisabledDefaultProps,
  addToCartOptions: null,
  attributionToken: null,
  availableQuantity: null,
  categories: [],
  codeOldCompanySku: null,
  companyAvailability: false,
  configurations: [],
  configurator: {},
  customerPrice: null,
  delayQuantity: null,
  discountPrice: null,
  exclusivity: null,
  flags: [],
  hasPrice: true,
  hasStock: true,
  image: {},
  imageSize: PRODUCTS_TYPES_FORMATS.MOSAIC,
  invoiceUnit: null,
  isFavorite: null,
  isRelatedProduct: false,
  isTableRow: false,
  mainSku: null,
  manufacturerSku: null,
  name: null,
  onAddPredictions: () => null,
  onClickCallback: () => null,
  pageName: null,
  path: null,
  publicPrice: null,
  refetchCart: () => null,
  saleUnit: null,
  salesPackaging: 1,
  sku: null,
  slug: null,
  splitPackaging: false,
  stockStatus: null,
  stocks: [],
  tableRowSize: null,
  weeeAmount: null,
};
export const ProductPropTypes = {
  ...ClassNamePropTypes,
  ...DisabledPropTypes,
  addToCartOptions: PropTypes.shape({
    dataLayer: PropTypes.shape({
      event: PropTypes.string,
    }),
    flashMessage: PropTypes.bool,
    link: PropTypes.bool,
    linkUrl: PropTypes.string,
    messages: PropTypes.shape({
      link: PropTypes.string,
      text: PropTypes.string,
      title: PropTypes.string,
      undo: PropTypes.string,
    }),
    modal: PropTypes.bool,
    predictions: PropTypes.bool,
    undo: PropTypes.bool,
  }),
  attributionToken: PropTypes.string,
  availableQuantity: PropTypes.number,
  brand: PropTypes.shape({ logo: PropTypes.shape({}), name: PropTypes.string }),
  breadcrumb: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      path: PropTypes.string,
      type: PropTypes.string,
    }),
  ),
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      depth: PropTypes.number,
      id: PropTypes.number,
      label: PropTypes.string,
    }),
  ),
  codeOldCompanySku: PropTypes.string,
  companyAvailability: PropTypes.bool,
  configurations: PropTypes.arrayOf(PropTypes.shape({})),
  configurator: PropTypes.shape({
    id: PropTypes.string,
    num_configurations: PropTypes.number,
  }),
  customerPrice: PropTypes.number,
  delayQuantity: PropTypes.number,
  discountPrice: PropTypes.number,
  exclusivity: PropTypes.string,
  flags: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      label: PropTypes.string,
      slug: PropTypes.string,
    }),
  ),
  hasPrice: PropTypes.bool,
  hasStock: PropTypes.bool,
  id: PropTypes.string.isRequired,
  image: PropTypes.shape({
    alt: PropTypes.string,
    path: PropTypes.string,
    url: PropTypes.string,
  }),
  imageSize: PropTypes.string,
  invoiceUnit: PropTypes.string,
  isFavorite: PropTypes.bool,
  isTableRow: PropTypes.bool,
  mainSku: PropTypes.string,
  manufacturerSku: PropTypes.string,
  name: PropTypes.string,
  onAddPredictions: PropTypes.func,
  onClickCallback: PropTypes.func,
  pageName: PropTypes.string,
  path: PropTypes.string,
  publicPrice: PropTypes.number,
  refetchCart: PropTypes.func,
  saleUnit: PropTypes.string,
  salesPackaging: PropTypes.number,
  sku: PropTypes.string,
  slug: PropTypes.string,
  splitPackaging: PropTypes.bool,
  stockStatus: PropTypes.string,
  stocks: PropTypes.arrayOf(
    PropTypes.shape({
      company: PropTypes.string,
      delay: PropTypes.number,
      quantity: PropTypes.number,
      warehouse: PropTypes.string,
    }),
  ),
  tableRowSize: PropTypes.oneOf(['small', 'medium', 'large']),
  weeeAmount: PropTypes.number,
};
